import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthDataService } from '../../services/auth-data.service';
import { IProvider } from '../../interfaces/provider';

export const providerResolver: ResolveFn<IProvider> = (route, state) => {
  const authDS = inject(AuthDataService);
  return authDS.getProviderById(route.queryParams.id);
};
